<template>
    <h2 class="border-bottom border-primary" :class="optional_class">
        <div class="title d-flex align-items-center">
            <i class="text-primary bi" :class="icon"></i>
            {{ title }}
        </div>
        <!-- 追加ボタン -->
        <slot/>
        <button-back :backTo="backTo"></button-back>
    </h2>
</template>

<script>
import ButtonBack from '@/shared/components/design/buttons/ButtonBack.vue';
export default {
    components: {
        ButtonBack,
    },
    name: 'SectionTitle',
    props: {
        title: {
            type: String,
            default: ''
        },
        optional_class: {
            type: String,
            default: ''
        },
        icon_class: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'bi-file-fill'
        },
        backTo: {
            type: Object,
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2 {display: flex; justify-content: space-between; align-items: inherit; margin: 1rem 0 1rem -.2rem; padding-bottom: .5rem; font-size: 1.4rem;}
    .title {position: relative;}
    .title i {margin-right: .7rem;}
    .btn {margin-left: 1rem;}
    .badge {position: absolute; top: -1.5rem; left: 0;}
    @media (min-width: 768px) {
        h2 {align-items: center; margin-top: 2.5rem;}
    }
</style>
